import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthserviceService } from 'src/app/service/authservice.service';
import { ContentServiceService } from 'src/app/service/content-service.service';
import { SubscriptionService } from 'src/app/service/subscription.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit {
  source: string = 'portal';
  mobile_number: string;
  unSubModalBox: boolean = false;
  unSub: boolean = false;
  clickId: string;
  ipAddress: string;
  agent: string;
  pubId: string;
  visitorid: string;
  referer: string = '0';
  unsubcribeResponse: any
  activation_date: string;
  expiry_date: string;
  issubscribed: any;

  constructor(private contentService: ContentServiceService,
    private _activatedRoute: ActivatedRoute,
    private authService: AuthserviceService,
    private subscriptionService: SubscriptionService,
    private http: HttpClient,
    private _router: Router) { }

  ngOnInit(): void {
    this.source = this._activatedRoute.snapshot.queryParamMap.get('source') ? this._activatedRoute.snapshot.queryParamMap.get('source') : 'portal';
    this.clickId = this._activatedRoute.snapshot.queryParamMap.get('ClkId') ? this._activatedRoute.snapshot.queryParamMap.get('ClkId') : '0';
    this.pubId = this._activatedRoute.snapshot.queryParamMap.get('pubId') ? this._activatedRoute.snapshot.queryParamMap.get('pubId') : '0';
    this.agent = encodeURI(window.navigator.userAgent.toLowerCase());
    this.activation_date = sessionStorage.getItem('subscriptionDate');
    this.expiry_date = sessionStorage.getItem('renewalDate');

    if (sessionStorage.getItem('isSubscribed') == '1') {
      this.unSub = true;
    }
  }

  unSubModal() {
    this.unSubModalBox = true;
  }
  closeModal() {
    console.log("click");
    this.unSubModalBox = false;

  }
  async unsubcribe() {
    await this.subscriptionService.unsubcribe();
    setTimeout(() => {
      this.unSubModal()
    }, 2000);  //2s
  }

}
